import TM from "@/api/ticket-management";

function removeCountdown() {
  localStorage.removeItem("expiredOrderTime");
}

const getDefaultState = () => {
  return {
    pageData: null,
    isPopState: false,
    discounts: null,
    boughtTickets: [],
    selectedArea: null,
    areaAssignment: false,
    seatAssignment: false,
    counterInterval: null,
    timer: 9999, // 倒數計時計
    reserveResponse: {},
    updateResponse: {},
    currentOrder: null,
    currentReserved: null,
    orderComplete: 0
  };
};

//init state
const state = getDefaultState();

const mutations = {
  SET_SELECTEDAREA: (state, area) => {
    state.selectedArea = area;
  },
  SET_TICKETS: (state, tickets) => {
    state.boughtTickets = tickets;
  },
  SET_AREAASSIGNMENT: (state, bool) => {
    state.areaAssignment = bool;
  },
  SET_SEATASSIGNMENT: (state, bool) => {
    state.seatAssignment = bool;
  },
  SET_DISCOUNT: (state, discounts) => {
    state.discounts = discounts;
  },
  SET_CURRENT_RESERVED: (state, currentReserved) => {
    // console.log(
    //   "[CURRENT_RESERVED] reservedLocalTime: ",
    //   new Date(JSON.parse(localStorage.getItem("reservedLocalTime")))
    // );
    let current = new Date().valueOf();
    current += (currentReserved.remainSecond - 5) * 1000;
    localStorage.setItem("orderTimeout", current);
    // console.log("CURRENT remainSecond", currentReserved.remainSecond);
    // console.log("CURRENT deadline", current);
    state.currentReserved = currentReserved;
  },
  CURRENT_ORDER: (state, currentOrder) => {
    state.currentOrder = currentOrder;
  },
  COUNT_DOWN_TIMER: state => {
    if (
      !state.reserveResponse ||
      !state.reserveResponse.products ||
      !state.reserveResponse.products.length
    )
      return;

    let deadline = Number(localStorage.getItem("orderTimeout"));
    let current = new Date().valueOf();
    state.timer = Math.ceil((deadline - new Date().valueOf()) / 1000);

    if (current < deadline && state.timer !== 9999 && !state.counterInterval) {
      state.counterInterval = setInterval(() => {
        state.timer = Math.ceil((deadline - new Date().valueOf()) / 1000);
        if (state.timer < 0) {
          clearInterval(state.counterInterval);
        }
      }, 1000);
    }
  },
  GET_CURRENT_RESERVED_ORDER: (state, data) => {
    state.reserveResponse = {
      ...data.order
    };
  },
  SET_TICKET_RESERVE_RESPONSE: (state, reserveResponse) => {
    if (!localStorage.getItem("orderTimeout")) {
      let current = new Date().valueOf();
      current += (reserveResponse.remainSecond - 5) * 1000;
      localStorage.setItem("orderTimeout", current);
      // console.log("RESERVE remainSecond", reserveResponse.remainSecond);
      // console.log("RESERVE deadline", current);
    }
    state.reserveResponse = reserveResponse;
  },
  SET_ORDER_UPDATE_RESPONSE: (state, updateResponse) => {
    state.updateResponse = updateResponse;
    let products = [];

    let tickets = updateResponse.products.reduce((accr, product, index) => {
      let prod = state.reserveResponse.products.find(
        p => p.productId === product.productId
      );

      delete prod.row;
      delete prod.column;
      delete prod.index;
      delete prod.nextIndex;
      products.push({
        ...prod,
        ...product
      });

      if (product.seats) {
        product.seats.forEach((seat, i) => {
          let val = {
            ...prod,
            ...seat,
            count: 1,
            applicants: product.applicants
          };
          if (product.culturePointProductInfos)
            val.culturePointProductInfos = product.culturePointProductInfos[i];
          accr.push(val);
        });
      } else {
        let val = {
          ...product,
          ...prod
        };
        if (product.culturePointProductInfos)
          val.culturePointProductInfos = {
            ...product.culturePointProductInfos[0],
            deductAmount: product.culturePointProductInfos.reduce(
              (accr, info) => {
                accr += info.deductAmount;
                return accr;
              },
              0
            )
          };
        accr.push(val);
      }
      return accr;
    }, []);
    if (updateResponse.products && updateResponse.products.length) {
      state.boughtTickets = tickets;
      state.reserveResponse = {
        ...state.reserveResponse,
        total: updateResponse.total,
        culturePointDeductAmount: updateResponse.culturePointDeductAmount,
        products,
        tickets
      };
    }
  },
  RESET: state => {
    clearInterval(state.counterInterval);
    localStorage.removeItem("orderTimout");
    state.timer = 9999;
    removeCountdown();
    Object.assign(state, getDefaultState());
  },
  POPSTATE: (state, popstate) => {
    state.isPopState = popstate;
  },
  PAGEDATA: (state, data) => {
    state.pageData = data;
  },
  SET_ORDERCOMPLETE: (state, data) => {
    state.orderComplete = data;
  }
};

const actions = {
  buyTickets({ commit }, tickets) {
    commit("SET_TICKETS", tickets);
  },
  setSelectedArea({ commit }, area) {
    commit("SET_SELECTEDAREA", area);
  },
  setAreaAssignment({ commit }, bool) {
    commit("SET_AREAASSIGNMENT", bool);
  },
  setSeatAssignment({ commit }, bool) {
    commit("SET_SEATASSIGNMENT", bool);
  },
  setDiscount({ commit }, discount) {
    commit("SET_DISCOUNT", discount);
  },
  countDownTimer({ commit }) {
    commit("COUNT_DOWN_TIMER");
  },
  setTimer({ commit }, timer) {
    commit("COUNT_DOWN_TIMER", timer || 15);
  },
  reserveTicket({ commit }, response) {
    commit("SET_TICKET_RESERVE_RESPONSE", response);
  },
  setCurrentReserved({ commit }, reserved) {
    commit("SET_CURRENT_RESERVED", reserved);
  },
  updateOrder({ commit }, response) {
    commit("SET_ORDER_UPDATE_RESPONSE", response);
  },
  resetOrderState({ commit }) {
    commit("RESET");
  },
  setPopState({ commit }, pop) {
    commit("POPSTATE", pop);
  },
  setPageData({ commit }, data) {
    commit("PAGEDATA", data);
  },
  resetCountdown() {
    if (state.counterInterval) clearInterval(state.counterInterval);
    removeCountdown();
  },
  setCurrentOrder({ commit }, order) {
    commit("CURRENT_ORDER", order);
  },
  async getCurrentReservedOrder({ commit }) {
    const { data } = await TM.getUserCurrentReservedOrder();
    commit("GET_CURRENT_RESERVED_ORDER", data.order ? data : null);
  },
  async setOrderComplete({ commit }, data) {
    commit("SET_ORDERCOMPLETE", data);
  }
};

const getters = {
  boughtTickets: state => state.boughtTickets,
  selectedArea: state => state.selectedArea,
  areaAssignment: state => state.areaAssignment,
  seatAssignment: state => state.seatAssignment,
  reserveResponse: state => state.reserveResponse,
  timer: state => state.timer,
  updateResponse: state => state.updateResponse,
  discounts: state => state.discounts,
  isPopState: state => state.isPopState,
  pageData: state => state.pageData,
  currentOrder: state => state.currentOrder,
  currentReserved: state => state.currentReserved,
  orderComplete: state => state.orderComplete
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
